import React, {useState} from 'react';
import {faTrashAlt, faFileUpload, faAlignLeft, faCopy} from '@fortawesome/free-solid-svg-icons';

import styles from './Escape.module.scss';
import ToolBar from "../../../UI/ToolBar/ToolBar";
import Buttons from "../../../UI/ToolBar/Buttons";
import UploadFile from "../../../UI/ToolBar/UploadFile";
import CodeEditor from "../../../UI/CodeEditor/CodeEditor";
import {formatJson} from "../../../utils/converters";
import {EscapeJson, UnescapeJson} from "../../../utils/ToolsCommon"

export default function Escape() {
    let [value, setValue] = useState('')
    let [copied, setCopied] = useState(false)
    let [formatError, setFormatError] = useState('')

    const handleChange = (newValue) => {
        setValue(newValue)
        setFormatError('')
    }

    const handleReset = () => handleChange('')

    const handleEscape = () => handleChange(EscapeJson(value))

    const handleUnescape = () => handleChange(UnescapeJson(value))

    const handleFormat = () => {
        try {
            handleChange(formatJson(value))
        } catch (err) {
            setFormatError(err.message || 'Unable to format')
        }
    }

    const handleCopy = () => {
        if (!value) return
        navigator.clipboard.writeText(value)
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
    }

    const handleUpload = (event) => {
        const file = event.target.files[0]
        if (!file) return
        const reader = new FileReader()
        reader.onloadend = () => handleChange(reader.result)
        reader.readAsText(file)
    }

    const primaryActionButtons = [
        {
            tip: "Reset",
            clickHandler: handleReset,
            icon: faTrashAlt,
        },
        {
            tip: "Escape characters",
            clickHandler: handleEscape,
            text: "Escape",
        },
        {
            tip: "Unescape characters",
            clickHandler: handleUnescape,
            text: "Unescape",
        }
    ]

    const outputActionButtons = [
        {
            tip: "Format",
            clickHandler: handleFormat,
            icon: faAlignLeft,
        },
        {
            tip: copied ? "Copied!" : "Copy to clipboard",
            clickHandler: handleCopy,
            icon: faCopy,
        },
    ]

    return (
        <div className={styles.main}>
            <ToolBar>
                <div className={styles.toolbarRow}>
                    <Buttons buttons={primaryActionButtons}/>
                    <div className={styles.toolbarRow} style={{justifyContent: "flex-end"}}>
                        <UploadFile id={'file-input-escape'} icon={faFileUpload} handler={handleUpload}
                                    tip={'Upload file'}/>
                        <Buttons buttons={outputActionButtons}/>
                    </div>
                </div>
            </ToolBar>
            {formatError && <div className={styles.error}>{formatError}</div>}
            <div className={styles.body}>
                <CodeEditor language="json" value={value} onChange={handleChange}/>
            </div>
        </div>
    );
}
